import { ApiConnector, DELETE, GET, POST } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/homeworks', true);
    return {
        HomeworkList: async (data, query) => await API(GET, '', false, query).call(false),
        saveGroupHW: async (data, query) => await API(POST, ``, false, query).call(data),
        createOldHw: async (data, query) => await API(POST, `/week/old`, false, query).call(data),
        getHomeworkSchema: async query => await API(GET, `/schema/templates`, false, query).call(false, true),
        copyBossTemplate: async data => await API(POST, `/custom/copy/boss`).call(data),
        copyTeacherTemplate: async data => await API(POST, `/custom/copy/teacher`).call(data),
        аssignedTemplate: async data => await API(POST, `/custom/asign`).call(data),
        getTemplatesMy: async () => await API(GET, `/custom/my`).call(),
        getTemplatesSign: async () => await API(GET, `/custom/sign`).call(),
        getTemplateMyById: async (id, query) => await API(GET, `/custom/my/${id}`, false, query).call(false, true),
        getTemplateSignById: async (id, query) => await API(GET, `/custom/sign/${id}`, false, query).call(false, true),
        getTemplateSchoolById: async (id, query) =>
            await API(GET, `/custom/boss/${id}`, false, query).call(false, true),
        deleteHwTeacher: async (data, query) => await API(DELETE, `/teacher`, false, query).call(data),

        deleteHwTeacherTemplate: async (data, query) =>
            await API(DELETE, `/custom/delete/${query.id}`, false).call(data),
        deleteMyTemplate: async id => await API(DELETE, `/custom/my/${id}`).call(),
        deleteSignTemplate: async id => await API(DELETE, `/custom/sign/${id}`).call(),
        saveModification: async data => await API(POST, `/custom/templates`).call(data),
        createNewHw: async (data, query) => await API(POST, `/week`, false, query).call(data),
        deleteHwAdmin: async id => await API(DELETE, `/templates/homework/${id}`).call(),
        getGroupHistoryHwNew: async (data, query) => await API(GET, `/history`, false, query).call(data),
        getGroupHistoryHwUsers: async (data, query) => await API(GET, `/history/users`, false, query).call(data),
        getGroupHistoryHwDate: async (data, query) => await API(GET, `/history/date`, false, query).call(data),
        getGroupHistoryHwSettings: async (data, query) => await API(GET, `/history/single`, false, query).call(data),
        getHwUsersStart: async (data, query) => await API(GET, `/users/start`, false, query).call(false),
        HomeworkListTeacher: async (data, query) => await API(GET, '/teacher', false, query).call(false),
        getCustomTopics: async () => await API(GET, `/custom/topics`).call(),
        getHomeworkCyclesStats: async (data, query) => await API(GET, '/student/stats', false, query).call(data),
    };
})();
